import { useAtomValue } from 'jotai'
import React from 'react'

import { searchWordAtom, showAllAtom } from '../../atoms'
import { useBrandAccountId } from '../useBrandAccountId'

export const useDocumentImagesInfiniteQueryKey = () => {
  const brandAccountId = useBrandAccountId()
  const showAll = useAtomValue(showAllAtom)
  const searchWord = useAtomValue(searchWordAtom)

  return React.useMemo(
    () =>
      [
        'DocumentImageInfiniteScrollList_DocumentImages',
        { brandAccountId, showAll, searchWord },
      ] as const,
    [brandAccountId, searchWord, showAll],
  )
}
